import { gql, type TypedDocumentNode } from "@apollo/client";
import type { EducationCredential, EducationCredentialType } from "./queries";

type EducationCredentialMutationResponse = {
  success: boolean;
  message: string;
  credential: EducationCredential | null;
};

export type CreateEducationCredentialMutationResponse = {
  createEducationCredential: EducationCredentialMutationResponse;
};

export type CreateEducationCredentialMutationVariables = {
  input: {
    personId: string;
    educationType: EducationCredentialType;
    description?: string;
    completedOn: string;
  };
};

export type UpdateEducationCredentialMutationResponse = {
  updateEducationCredential: EducationCredentialMutationResponse;
};

export type UpdateEducationCredentialMutationVariables = {
  input: {
    id: string;
    educationType: EducationCredentialType;
    description?: string;
    completedOn: string;
  };
};

export type DeleteEducationCredentialMutationResponse = {
  deleteEducationCredential: EducationCredentialMutationResponse;
};

export type DeleteEducationCredentialMutationVariables = {
  input: {
    id: string;
  };
};

const EDUCATION_CREDENTIAL_MUTATION_FIELDS = gql`
  fragment EducationCredentialMutationFields on BackofficeEducationCredential {
    id
    legacyId
    sourceSystem
    educationType
    description
    startedOn
    endedOn
    completedOn
    status
    creditType
    creditsAwarded
    syncedAt
    createdAt
    updatedAt
  }
`;

export const CREATE_EDUCATION_CREDENTIAL_MUTATION: TypedDocumentNode<
  CreateEducationCredentialMutationResponse,
  CreateEducationCredentialMutationVariables
> = gql`
  mutation CreateEducationCredential($input: CreateEducationCredentialInput!) {
    createEducationCredential(input: $input) {
      success
      message
      credential {
        ...EducationCredentialMutationFields
      }
    }
  }
  ${EDUCATION_CREDENTIAL_MUTATION_FIELDS}
`;

export const DELETE_EDUCATION_CREDENTIAL_MUTATION: TypedDocumentNode<
  DeleteEducationCredentialMutationResponse,
  DeleteEducationCredentialMutationVariables
> = gql`
  mutation DeleteEducationCredential($input: DeleteEducationCredentialInput!) {
    deleteEducationCredential(input: $input) {
      success
      message
      credential {
        ...EducationCredentialMutationFields
      }
    }
  }
  ${EDUCATION_CREDENTIAL_MUTATION_FIELDS}
`;

export const UPDATE_EDUCATION_CREDENTIAL_MUTATION: TypedDocumentNode<
  UpdateEducationCredentialMutationResponse,
  UpdateEducationCredentialMutationVariables
> = gql`
  mutation UpdateEducationCredential($input: UpdateEducationCredentialInput!) {
    updateEducationCredential(input: $input) {
      success
      message
      credential {
        ...EducationCredentialMutationFields
      }
    }
  }
  ${EDUCATION_CREDENTIAL_MUTATION_FIELDS}
`;
